/* eslint-disable no-unused-vars */
import React, { ReactNode, useEffect } from 'react';
import { Navigate, useMatch, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
  logout,
  selectIsAuth,
  selectTokensManager,
  selectUser,
} from 'store/auth/authSlice';
import Page from 'pages/page';
import isString from 'lodash-es/isString';

export default function RedirrectWrapper({
  children,
}: {
  children: ReactNode;
}) {
  const dispatch = useAppDispatch();
  const isAuth = useAppSelector(selectIsAuth);

  const tokens = useAppSelector(selectTokensManager);
  const user = useAppSelector(selectUser);

  let pageName = '';
  const params = useParams();
  const mainChecker = useMatch('/:name/*')?.params.name;
  const adminChecker = useMatch('/admin/:section')?.params.section;
  const isAdminPage = mainChecker === 'admin' || adminChecker ? true : false;

  // Костыль, так как поля обычного класса нельзя использовать как зависимость хука
  // Тащить mobx пока что не хочется, учитывая точечность проблемы и статус проекта
  useEffect(() => {
    const interval = setInterval(() => {
      if (!tokens.isValidTokens) {
        dispatch(logout());
      }
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [tokens]);

  if (!tokens.isValidTokens) {
    return <Navigate to="/login" replace={true} />;
  }

  if (!isAuth) {
    return (
      <Page isAdminPage={isAdminPage} isLoginPage={false} name="loading">
        {children}
      </Page>
    );
  }

  // В некоторые разделы можно зайти только определенным ролям
  if (user?.role !== 'admin') {
    if (isAdminPage) {
      return <Navigate to="/photos" replace={true} />;
    }

    if (user?.role !== 'editor') {
      if (mainChecker === 'upload') {
        return <Navigate to="/photos" replace={true} />;
      }
    }
  }

  switch (true) {
    case isString(params.cardId):
      pageName = 'card';
      break;
    case isString(adminChecker):
      pageName = adminChecker || '';
      break;
    default:
      pageName = mainChecker || 'photos';
  }

  return (
    <Page name={pageName} isAdminPage={isAdminPage} isLoginPage={false}>
      {children}
    </Page>
  );
}
